export default "__VITE_ASSET__Cc7UxxGX__"